export class ApiError extends Error {
  constructor(error) {
    super(error.message)

    for (const property in error) {
      this[property] = error[property]
    }
  }
}
